/** @jsxRuntime classic */

/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import React from 'react';
import classic from './themes/classic';
import wizard from './themes/wizard';
import modern from './themes/modern';
var FormThemeContext = React.createContext(
/** @type {FormThemeVariant | FormTheme | undefined} */
undefined);
export default function useFormTheme() {
  var value = React.useContext(FormThemeContext);
  var layout = typeof value === 'string' ? layouts[value] : value;
  return layout;
}
/**
 *
 * @param {object} props
 * @param {FormThemeVariant | FormTheme | undefined} props.value
 * @param {React.ReactNode} props.children
 * @returns
 */

export function FormThemeProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  var layout = typeof value === 'string' ? layouts[value] : value;
  return jsx(FormThemeContext.Provider, {
    value: layout
  }, children);
}
var layouts = {
  classic: classic,
  wizard: wizard,
  modern: modern
};
/** @typedef {keyof typeof layouts} FormThemeVariant */

/**
 * TODO define the FormLayout attributes.
 *  @typedef {{
 *      form: import('theme-ui').SxStyleProp,
 *      fieldLayout: import('theme-ui').SxStyleProp,
 *      label: import('theme-ui').SxStyleProp,
 *      field: import('theme-ui').SxStyleProp,
 *      checkbox: import('theme-ui').SxStyleProp,
 *      radio: import('theme-ui').SxStyleProp,
 *      input: import('theme-ui').SxStyleProp,
 *      textArea: import('theme-ui').SxStyleProp,
 *      description: import('theme-ui').SxStyleProp,
 *      warning: import('theme-ui').SxStyleProp,
 *      error: import('theme-ui').SxStyleProp,
 * }} FormTheme
 */